// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0be034db","453":"3aacc994","667":"438ff19c"}[chunkId] + ".chunk.js";
};